<template>
  <section :id="anchor" class="detail-layout-section">
    <div v-if="title" class="detail-layout-section-title">
      <slot name="title">
        <h3>{{ title }}</h3>
      </slot>
    </div>
    <div class="detail-layout-section-content">
      <slot />
    </div>
  </section>
</template>

<script lang="ts" setup>
/* Original Nuxt 2 code:
import Vue from 'vue'
import { PropOptions } from 'vue/types'
export default Vue.extend({
 name: 'DetailLayoutSection',
 props: {
   title: {
     type: String,
     default: '',
   } as PropOptions<string>,
   anchor: {
     type: String,
     default: '',
   } as PropOptions<string>,
 },
 mounted() {
   const tables = document.getElementsByClassName('table')
   Array.from(tables).forEach(function (el) {
     const tableWidth = el.clientWidth
     const tableContainerWidth = el?.parentElement?.clientWidth
     if (tableContainerWidth != null && tableWidth > tableContainerWidth) {
       el.classList.add('is-overflow')
     }
   })
 },
})
*/

withDefaults(
  defineProps<{
    title?: string
    anchor?: string
  }>(),
  {
    title: '',
    anchor: '',
  },
)

onMounted(() => {
  const tables = document.getElementsByClassName('table')
  Array.from(tables).forEach(function (el) {
    const tableWidth = el.clientWidth
    const tableContainerWidth = el?.parentElement?.clientWidth
    if (tableContainerWidth != null && tableWidth > tableContainerWidth) {
      el.classList.add('is-overflow')
    }
  })
})
</script>

<style lang="postcss">
.detail-layout-section {
  @apply relative;
  &:not(:last-child) {
    @apply pb-size-4 desktop:pb-size-2 widescreen:pb-size-1;
  }
}
.detail-layout-section-title {
  @apply relative pt-size-7 desktop:pt-size-6;
  &:after {
    content: '';
    @apply absolute left-0 top-0 h-[1px] w-[80px] bg-grey;
  }
  h3 {
    @apply mb-size-5 text-size-4-5 font-bold text-scheme-invert desktop:mb-size-4 desktop:text-size-4;
  }
}
</style>
